// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_29TqL","tooltip":"_2gWB5"};